import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { CheckIcon, WarningIcon, ErrorIcon } from "./StatusIcons/StatusIcons";

function Summary(props) {    
	let { deviceData } = props;



	// Helper function to get status icon and color
	const getStatusIconAndColor = (status) => {
		switch (status) {
			case "registered":
				return {
					icon: <CheckIcon />,
					textColor: "#73C580"
				};
			case "not_registered":
				return {
					icon: <WarningIcon />,
					textColor: "#D91A1A"
				};
			case "deactivated":
				return {
					icon: <ErrorIcon />,
					textColor: "#D91A1A"
				};
			default:
				return {
					icon: "?",
					color: "#D91A1A", // Default red
					textColor: "#D91A1A"
				};
		}
	};

	// Helper function to get analysis status color
	const getAnalysisStatusColor = (analysisStatus) => {
		if (analysisStatus === "automatically_approved") {
			return "#73C580"; // Green
		} else if (analysisStatus === "automatically_reproved") {
			return "#D91A1A"; // Red
		}
		return "#000000"; // Default black
	};

	const { t } = useTranslation();

	const getStatus = (status, ratioColor) => {
		const statusInfo = getStatusIconAndColor(status);
		return (<span style={{color: statusInfo.textColor}}>{t(status)}</span>);
	}

	const statusInfo = getStatusIconAndColor(deviceData.status);
	const analysisStatusColor = getAnalysisStatusColor(deviceData.analysis_status);

	let lastAnalysisReason = '';
	if (Array.isArray(deviceData.analysis_status_events) && deviceData.analysis_status_events.length > 0) {
		const lastEvent = deviceData.analysis_status_events[deviceData.analysis_status_events.length - 1];
		lastAnalysisReason = lastEvent.reason_description || lastEvent.reason || '';
	}

	return (
		<div className="analysisCard">
			<div className={["blueText", "subtitleSize"].join(" ")}>Resumo</div>
				<div style={{display:"flex"}} className="internalCardContainer">
					<div 
						style={{
							margin: "0px 5px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center"
						}} 
						className={["circle", "big", "normalText", "subtitleSize", "bold"].join(" ")}
					>
						{statusInfo.icon}
					</div>
					
					<div style={{display: "flex", flexDirection: "column", justifyContent: "center", margin: "auto 5px"}}>
						<div className={["normalText", "normalMediumSize"].join(" ")}>
							Status: {getStatus(deviceData.status)}
						</div>

						<div className={["normalText", "normalMediumSize"].join(" ")}>
							Análise: <span style={{color: analysisStatusColor}}>{t(deviceData.analysis_status)}</span>
						</div>

						<div className={["normalText", "normalMediumSize"].join(" ")}>
							Razão: <span>{lastAnalysisReason ? lastAnalysisReason : '-'}</span>
						</div>
					</div>
				</div>
				
				<div className="internalCardContainer" style={{display: 'flex', flexDirection: 'column'}}>
				{(deviceData.status_events.length!==0) &&
				<div className={["blueText", "normalMediumSize","bold"].join(" ")} style={{marginTop: '15px'}}>
					{`${t("device_events")}:`}
				</div>}
				{deviceData.status_events.map((status_event, index) => (
					<div className={["normalSmallSize","bold"].join(" ")} style={{marginTop: '15px'}}>
						{t(status_event.new_status) + " - " + moment(status_event.event_date).format("DD/MM/YYYY HH:mm")}
					</div>
                ))}
			</div>
		</div>
	);
}

export default Summary;
